import { render, staticRenderFns } from "./TransferRegistration.vue?vue&type=template&id=6172067a"
import script from "./TransferRegistration.vue?vue&type=script&lang=js"
export * from "./TransferRegistration.vue?vue&type=script&lang=js"
import style0 from "./TransferRegistration.vue?vue&type=style&index=0&id=6172067a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports